import cn from 'classnames';
import React, { useEffect } from 'react';

import { Button, Divider, Typography } from '@sravni/react-design-system';
import { OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import { sendProductClickEvent, sendProductViewEvent } from '../../../../helpers/analyticsEvents';
import { useProductData } from '../../../../hooks/useProductData';
import type { IOffer } from '../../../../interfaces/offers';
import styles from '../../product-block.module.scss';
import { CommonCard } from '../CommonCard';
import { Pixel } from '../Pixel';

export interface IOfferBlockProps {
  isMobile: boolean;
  item: IOffer;
  type: OFFERS_TYPE;
  organization;
}

export const Card = ({ type, item, organization, isMobile }: IOfferBlockProps) => {
  const {
    bankName,
    logoSrc,
    isCard,
    offerTitle,
    ratingValue,
    conditions,
    isPartnerCard,
    noticeAboutAdvertisement,
    buttonLabel,
    label,
    clickBlockEvent,
    viewBlockEvent,
    clickUrl,
    viewUrl,
  } = useProductData({ type, item, organization });

  const handleClick = () => {
    sendProductClickEvent(clickBlockEvent);
  };

  useEffect(() => {
    sendProductViewEvent(viewBlockEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.wrapper}>
      <Pixel url={viewUrl} />
      <a className={styles.block} href={clickUrl} onClick={handleClick} target="_blank" rel="noreferrer">
        <CommonCard
          type={type}
          organization={organization}
          bankName={bankName}
          ratingValue={ratingValue}
          isPartnerCard={isPartnerCard}
          label={label}
          itemId={item._id}
          conditions={conditions}
          offerTitle={offerTitle}
          isMobile={isMobile}
          logoSrc={logoSrc}
          isCard={isCard}
        />
        {isMobile && <Divider size={16} />}
        <div>
          <Button size={36} variant="primary" block className={styles.button}>
            {buttonLabel}
          </Button>
          {noticeAboutAdvertisement && (
            <Typography.Text size={8} className={cn(styles.notification, 'h-mt-4 h-color-D20')} nowrap>
              {noticeAboutAdvertisement}
            </Typography.Text>
          )}
        </div>
      </a>
    </div>
  );
};
